function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M21.99 10.84c-.02-.48-.1-.95-.25-1.4a5.347 5.347 0 00-5.09-3.72h-2.79c-.58 0-.62-.06-.93-.47l-1.4-1.86c-.65-.87-1.16-1.4-2.79-1.4H6.41c-2.44 0-4.42 1.98-4.42 4.42v10.23c0 2.95 2.4 5.35 5.35 5.35h9.3c2.95 0 5.35-2.4 5.35-5.35v-5.58a.81.81 0 000-.22z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.58 19.7c-2.11.15-2.11 3.21 0 3.36h5.01c.61 0 1.19-.22 1.64-.63 1.48-1.29.69-3.89-1.26-4.13-.7-4.22-6.81-2.62-5.36 1.4"
})));